// Bixbite Pricing Data - USD
export const pricingPlansUSD = [
  {
    name: 'Raw Bixbite',
    inputPrice: '$0.5',
    outputPrice: '$1',
    icon: 'DiamondIcon',
    gradient: 'linear-gradient(135deg, #00796b 0%, #4db6ac 100%)',
    shadowColor: 'rgba(0, 121, 107, 0.3)',
    popular: false,
  },
  {
    name: 'Polished Bixbite',
    inputPrice: '$1',
    outputPrice: '$2',
    icon: 'StarIcon',
    gradient: 'linear-gradient(135deg, #004d40 0%, #00796b 100%)',
    shadowColor: 'rgba(0, 77, 64, 0.3)',
    popular: false,
  },
  {
    name: 'Radiant Bixbite',
    inputPrice: '$2.5',
    outputPrice: '$8.5',
    icon: 'AutoAwesomeIcon',
    gradient: 'linear-gradient(135deg, #0288d1 0%, #4fc3f7 100%)',
    shadowColor: 'rgba(2, 136, 209, 0.3)',
    popular: false,
  },
  {
    name: 'Flawless Bixbite',
    inputPrice: '$4',
    outputPrice: '$10',
    icon: 'WorkspacePremiumIcon',
    gradient: 'linear-gradient(135deg, #f9a825 0%, #ffd54f 100%)',
    shadowColor: 'rgba(249, 168, 37, 0.3)',
    popular: true,
  },
];

export const additionalPricingUSD = [
  {
    category: 'One-Time Charges',
    items: [
      'Create Web Application: $0.99',
      'Create Mobile Application: $0.99',
      'Create RAG Application: $1.99',
    ],
  },
  {
    category: 'Hourly Hosting Charges',
    items: [
      'Web Hosting: $0.099/hour',
      'Mobile Hosting: $0.099/hour',
      'RAG Hosting: $0.099/hour',
      'Publish to Your Domain: $0.069/hour (in addition to hosting)',
    ],
  },
  {
    category: 'Per-Click Charges',
    items: [
      'Download Source Code: $0.99/click',
      'Push to GitHub: $0.99/click',
      'Download Mobile Build: $0.99/click',
      'Get API Details for RAG Application: free',
      'Create Mobile Build: $5/click',
      'Publish to App Store: $5/click',
      'Publish to Play Store: $5/click',
    ],
  },
  {
    category: 'Speech Services',
    items: [
      'Speech to Text: $6 per million tokens',
      'Text to Speech: $12 per million tokens',
    ],
  },
];

